export interface CurrencyRate {
  code: string;
  description: string;
  /** Kept from the source. Display rounding uses `decimals`, not this factor. */
  roundingFactor: number;
  decimals: number;
  validFrom: string;
  /** Local-currency units represented by `change` foreign units. Usually 1. */
  localValue: number;
  /** Local-currency units for 1 unit of this currency. */
  change: number;
}

export interface CurrencyRateDto {
  code: string;
  description: string;
  roundingFactor: number;
  decimals: number;
  validFrom: string;
  localValue: number;
  change: number;
}

export function mapCurrencyRateDto(dto: CurrencyRateDto): CurrencyRate | null {
  const code = dto.code?.trim().toUpperCase();
  if (!code || !Number.isFinite(dto.change) || dto.change === 0) {
    return null;
  }

  return {
    code,
    description: dto.description?.trim() || code,
    roundingFactor: dto.roundingFactor,
    decimals: Number.isFinite(dto.decimals) ? dto.decimals : 2,
    validFrom: dto.validFrom,
    localValue: dto.localValue || 1,
    change: dto.change,
  };
}
